import React, { useEffect, useState, useMemo } from "react";
import DataTable from "react-data-table-component";
import { useForm, Controller } from "react-hook-form";
import { get, post } from "../../services/api";
import Select from "react-select";
import { toast } from "react-toastify";
import { customTableStyles } from "../../assets/CustomTableStyles";

function AssignTeacher() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");

  const [triggerRerender, setTriggerRerender] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const {
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    setValue,
    getValues,
    trigger,
    reset,
  } = useForm({
    defaultValues: {},
  });

  const [centerId, setCenterId] = useState(savedCenterId || null);
  const [centersData, setCentersData] = useState([]);
  const [classSectionsData, setClassSectionsData] = useState([]);
  const [subjectsData, setSubjectsData] = useState([]);
  const [teachersData, setTeachersData] = useState([]);

  useEffect(() => {
    const fetchCenters = async () => {
      try {
        const response = await get(
          `Dropdown/GetAllCentersByOrganizationId?organizationId=${organizationId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setCentersData(response);

        if (savedCenterId) {
          const selectedCenter = response.find(
            (center) => center.id === parseInt(savedCenterId, 10)
          );

          if (selectedCenter) {
            setValue("centerId", {
              value: selectedCenter.id,
              label: selectedCenter.name,
            });

            fetchClassSectionsByCenterId(savedCenterId);
          }
        }
      } catch (error) {
        console.error("Error fetching centers:", error);
      }
    };

    fetchCenters();
    fetchSubjectsByClassSectionId();
  }, []);

  const fetchClassSectionsByCenterId = async (centerId) => {
    try {
      if (centerId) {
        const response = await get(
          `ClassSection/GetAllClassSectionByCenterId?centerId=${centerId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setClassSectionsData(response);
      } else {
        setClassSectionsData([]);
      }
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  const fetchSubjectsByClassSectionId = async (id) => {
    const currentCenterId = id || centerId;
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    try {
      const response = await get(
        `Subject/GetSectionSubjectAssignTeacherByCenterId?centerId=${currentCenterId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const subjects =
        response?.sectionSubjects.flatMap((sectionSubject) =>
          sectionSubject.classSectionSubjectsDtos.map((subject) => ({
            ...subject,
            teacherDetails: teachersData.find(
              (teacher) => teacher.id === subject.teacherId1
            ),
          }))
        ) || [];

      setSubjectsData(subjects);
      console.log(subjects);
    } catch (error) {
      console.error("Error fetching subjects:", error);
    }
  };

  useEffect(() => {
    const getUsersByCenterIdAndRoleId = async () => {
      try {
        const response = await get(
          `UserAuthentication/GetUsersByCenterIdAndRoleId?centerId=${centerId}&roleId=${7}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setTeachersData(response);
      } catch (error) {
        console.error("Error fetching teachers:", error);
      }
    };
    getUsersByCenterIdAndRoleId();
  }, [centerId]);

  const columns = [
    {
      name: "ID",
      selector: (row) => row.subjectId,
      sortable: true,
      omit: true,
      // width: "60px",
    },
    {
      name: "Sr No.",
      cell: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      sortable: false,
      // width: "60px",
    },
    {
      name: "Class",
      selector: (row) => row.className,
      sortable: true,
    },
    {
      name: "Section",
      selector: (row) => row.sectionName,
      sortable: true,
    },
    {
      name: "Subject",
      selector: (row) => row.subjectName,
      sortable: true,
    },
    {
      name: "Teacher",
      width: "300px",
      cell: (row) => (
        <Controller
          name={`teacherId1-${row.subjectId}-${row.sectionId}`}
          control={control}
          defaultValue={
            row.teacherId1
              ? { value: row.teacherId1, label: row.teacherName1 }
              : null
          } // Set default value from row or null

          render={({ field }) => (
            <Select
              {...field}
              options={teachersData.map((teacher) => ({
                value: teacher.id,
                label: `${teacher.firstName} ${teacher.lastName}`,
              }))}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 1050 }),
                menu: (base) => ({ ...base, width: "170px" }),
                control: (base) => ({ ...base, width: "170px" }),
              }}
              onChange={(selectedOption) => {
                field.onChange(selectedOption); // Update the field value
                setValue(
                  `teacherId1-${row.subjectId}-${row.sectionId}`,
                  selectedOption
                );
                trigger(`teacherId1-${row.subjectId}-${row.sectionId}`);
              }}
              className="react-select-style"
              classNamePrefix="react-select-style-pref"
              isClearable
              value={
                field.value && field.value.value ? field.value : null
              } // Use field.value for the current value
            />
          )}
        />
      ),
    },
    // {
    //   name: "Teacher Name 2",
    //   width: "300px",
    //   cell: (row) => (
    //     <Controller
    //       name={`teacherId2-${row.subjectId}-${row.sectionId}`}
    //       control={control}
    //       defaultValue={{ value: row.teacherId2, label: row.teacherName2 }} // Set default value from row
    //       render={({ field }) => (
    //         <Select
    //           {...field}
    //           options={teachersData.map((teacher) => ({
    //             value: teacher.id,
    //             label: `${teacher.firstName} ${teacher.lastName}`,
    //           }))}
    //           menuPortalTarget={document.body}
    //           styles={{
    //             menuPortal: (base) => ({ ...base, zIndex: 1050 }),
    //             menu: (base) => ({ ...base, width: "170px" }),
    //             control: (base) => ({ ...base, width: "170px" }),
    //           }}
    //           onChange={(selectedOption) => {
    //             field.onChange(selectedOption); // Update the field value
    //             setValue(
    //               `teacherId2-${row.subjectId}-${row.sectionId}`,
    //               selectedOption
    //             );
    //             trigger(`teacherId2-${row.subjectId}-${row.sectionId}`);
    //           }}
    //           className="react-select-style"
    //           classNamePrefix="react-select-style-pref"
    //           isClearable
    //           value={field.value} // Use field.value for the current value
    //         />
    //       )}
    //     />
    //   ),
    // },
    {
      name: "Is Class Teacher",
      width: "150px",
      center: true,
      cell: (row) => {
        // Get current teachers assigned to this subject row
        const teacherId1 =
          getValues(`teacherId1-${row.subjectId}-${row.sectionId}`)?.value || 0;
        const teacherId2 =
          getValues(`teacherId2-${row.subjectId}-${row.sectionId}`)?.value || 0;
        const hasTeacher = teacherId1 || teacherId2;

        return (
          <Controller
            name={`isClassTeacher-${row.subjectId}-${row.sectionId}-${row.classId}`}
            control={control}
            defaultValue={row.isClassTeacher || false}
            render={({ field: { value } }) => (
              <input
                className="form-check-input"
                type="checkbox"
                checked={value}
                disabled={!hasTeacher && !value} // Disable only if no teacher and trying to check
                onChange={(e) => {
                  // Prevent checking if no teacher is assigned
                  if (!hasTeacher && e.target.checked) {
                    toast.warn(
                      "Please assign at least one teacher before making them Class Teacher."
                    );
                    return;
                  }

                  const success = handleClassTeacherCheckboxChange(
                    row,
                    e.target.checked
                  );

                  // Revert checkbox visually if validation failed
                  if (!success) {
                    e.target.checked = !e.target.checked;
                  }
                }}
              />
            )}
          />
        );
      },
    },
    {
      name: "Action",
      selector: (row) => (
        <button
          className="btn btn-outline-primary px-3 py-1"
          onClick={() => handleAssignTeacherSaveBtnClick(row)}
          type="button"
        >
          Save
        </button>
      ),
    },
  ];

  useEffect(() => {
    if (subjectsData.length > 0) {
      subjectsData.forEach((subject) => {
        const teacher = teachersData.find(
          (teacher) => teacher.id === subject.teacherId
        );
        setValue(
          `teacherId-${subject.subjectId}`,
          teacher
            ? {
                value: teacher.id,
                label: `${teacher.firstName} ${teacher.lastName}`,
              }
            : null
        );
        setValue(
          `isClassTeacher-${subject.subjectId}-${subject.sectionId}`,
          subject.isClassTeacher
        );
      });
    }
  }, [subjectsData, teachersData, setValue]);

  const handleClassTeacherCheckboxChange = (currentRow, isChecked) => {
    const classId = currentRow.classId;
    const sectionId = currentRow.sectionId;

    // Get the teacher who will be class teacher (from Teacher 1 or Teacher 2 in current row)
    const teacherId1 =
      getValues(`teacherId1-${currentRow.subjectId}-${sectionId}`)?.value || 0;
    const teacherId2 =
      getValues(`teacherId2-${currentRow.subjectId}-${sectionId}`)?.value || 0;

    const candidateTeacherId = isChecked ? teacherId1 || teacherId2 : 0;

    if (isChecked && candidateTeacherId === 0) {
      toast.error(
        "Please assign a teacher (Teacher 1 or Teacher 2) before making them Class Teacher."
      );
      return false;
    }

    if (isChecked && candidateTeacherId) {
      // Check if this teacher is already class teacher in ANY OTHER class-section
      const isAlreadyClassTeacher = subjectsData.some((row) => {
        // Skip the current row we're editing
        if (row.sectionSubjectId === currentRow.sectionSubjectId) return false;

        const rowTeacherId1 =
          getValues(`teacherId1-${row.subjectId}-${row.sectionId}`)?.value || 0;
        const rowTeacherId2 =
          getValues(`teacherId2-${row.subjectId}-${row.sectionId}`)?.value || 0;
        const rowIsClassTeacher = getValues(
          `isClassTeacher-${row.subjectId}-${row.sectionId}-${row.classId}`
        );

        return (
          rowIsClassTeacher &&
          (rowTeacherId1 === candidateTeacherId ||
            rowTeacherId2 === candidateTeacherId)
        );
      });

      if (isAlreadyClassTeacher) {
        toast.error(
          "This teacher is already assigned as Class Teacher in another class."
        );
        return false;
      }

      // Enforce only ONE class teacher per class-section
      subjectsData.forEach((row) => {
        if (
          row.classId === classId &&
          row.sectionId === sectionId &&
          row.sectionSubjectId !== currentRow.sectionSubjectId // don't uncheck self
        ) {
          setValue(
            `isClassTeacher-${row.subjectId}-${row.sectionId}-${row.classId}`,
            false
          );
        }
      });
    }

    // Finally, update the current checkbox
    setValue(
      `isClassTeacher-${currentRow.subjectId}-${currentRow.sectionId}-${currentRow.classId}`,
      isChecked
    );

    return true;
  };

  const handleAssignTeacherSaveBtnClick = (row) => {
    const selectedTeacher1 = getValues(
      `teacherId1-${row.subjectId}-${row.sectionId}`
    );
    const selectedTeacher2 = getValues(
      `teacherId2-${row.subjectId}-${row.sectionId}`
    );
    const isClassTeacher = getValues(
      `isClassTeacher-${row.subjectId}-${row.sectionId}-${row.classId}`
    );

    const payload = {
      sectionSubjectId: row.sectionSubjectId,
      teacherId1: selectedTeacher1?.value || 0,
      teacherId2: selectedTeacher2?.value || 0,
      isClassTeacher: !!isClassTeacher, // ensure boolean
    };

    saveData(payload);
  };

  const saveData = async (formData) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    try {
      const response = await post(
        "Subject/AddUpdateSectionSubjectTeacherAssignmentAsync",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.isSuccess) {
        toast.success("Success!");
        // fetchSubjectsByClassSectionId(formData.classSectionId); // Refresh subjects after saving
      } else {
        toast.error(response?.message || "Save failed. Please try again.");
      }
    } catch (error) {
      console.error("Error.", error);
    }
  };
  const handleSaveAll = async () => {
    const allPromises = subjectsData.map(async (row) => {
      const selectedTeachers1 =
        getValues(`teacherId1-${row.subjectId}-${row.sectionId}`)?.value || 0;
      const selectedTeachers2 =
        getValues(`teacherId2-${row.subjectId}-${row.sectionId}`)?.value || 0;

      const isClassTeacher =
        getValues(
          `isClassTeacher-${row.subjectId}-${row.sectionId}-${row.classId}`
        ) || false;

      // Prepare the payload
      const payload = {
        sectionSubjectId: row.sectionSubjectId,
        teacherId1: selectedTeachers1,
        teacherId2: selectedTeachers2,
        isClassTeacher,
      };

      // Call the save function
      return saveData(payload); // Return the promise from saveData
    });

    try {
      // Wait for all saves to complete
      await Promise.all(allPromises);
      toast.success("All data saved successfully!"); // Show success once
    } catch (error) {
      toast.error("Error saving some data. Please check the console."); // Show error once
      console.error("Error saving data:", error);
    }
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Assign Teacher to Subjects</h2>
      </div>

      <div className="row gx-2 mb-3">
        <div className="col-md-3">
          <label className="form-label">Center</label>
          <Controller
            name="centerId"
            control={control}
            // rules={{ required: "This field is required." }}
            render={({ field }) => (
              <Select
                {...field}
                options={centersData.map((center) => ({
                  value: center.id,
                  label: center.name,
                }))}
                //isDisabled={savedCenterId !== "0"}
                isDisabled={savedCenterId && savedCenterId !== "0"}
                onChange={(selectedOption, actionMeta) => {
                  if (actionMeta.action === "clear") {
                    setValue("centerId", null);
                    setValue("classSectionId", null);
                    setClassSectionsData([]);
                    setSubjectsData([]); // Clear table data
                  } else {
                    setValue("centerId", selectedOption);
                    setValue("classSectionId", null);
                    setCenterId(selectedOption.value);
                    fetchClassSectionsByCenterId(selectedOption.value);
                    fetchSubjectsByClassSectionId(selectedOption.value); // Add this line
                  }
                  trigger("centerId");
                }}
                className="react-select-style"
                classNamePrefix="react-select-style-pref"
                isClearable
              />
            )}
          />
          {errors.centerId && (
            <small className="text-danger">{errors.centerId.message}</small>
          )}
        </div>
        <div className="col-md-2 d-none">
          <label className="form-label">Class - Section</label>
          <Controller
            name="classSectionId"
            control={control}
            // rules={{ required: "This field is required." }}
            render={({ field }) => (
              <Select
                {...field}
                options={classSectionsData.map((classSection) => ({
                  value: classSection.id,
                  label: classSection.name,
                }))}
                onChange={(selectedOption, actionMeta) => {
                  if (actionMeta.action === "clear") {
                    setValue("classSectionId", null);
                    setSubjectsData([]);
                    // setTeachersData([]);
                  } else {
                    setValue("classSectionId", selectedOption);
                    setSubjectsData([]);

                    // setTriggerRerender((prev) => !prev);
                  }
                  trigger("classSectionId");
                }}
                className="react-select-style"
                classNamePrefix="react-select-style-pref"
                isClearable
              />
            )}
          />
          {errors.classSectionId && (
            <small className="text-danger">
              {errors.classSectionId.message}
            </small>
          )}
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          {/* <div className="d-flex justify-content-end">
            <button
              className="btn btn-primary"
              onClick={handleSaveAll}
              disabled={isSubmitting}
            >
              Save All
            </button>
          </div> */}
          <DataTable
            columns={columns}
            data={subjectsData}
            pagination
            dense
            customStyles={customTableStyles}
            onChangePage={setCurrentPage}
            onChangeRowsPerPage={setRowsPerPage}
          />
        </div>
      </div>
    </>
  );
}

export default AssignTeacher;
